// client/src/utils/sessionEnd.generated.js
//
// GENERATED - do not edit by hand.
//
// Copied from packages/core/src/auth/sessionEnd.js by tools/sync-shared.py. Edit the core file and re-run that
// script; `node tools/marks-sheet-conformance.mjs` asserts this copy has not
// drifted from it.
//
// The phone imports the original. The web cannot (packages/core is outside
// client/src, and the CRA build will not resolve it), so it gets this. They must
// stay identical - a rule that exists twice and differs is the whole class of
// bug these files were written to end.
//
// Why a session ended. Both clients must write and read the same key
// with the same words in it, or the login screen explains an ending the
// other client never recorded.

export function recordSessionEnd(reason) {
  if (!reason) return;
  try { localStorage.setItem(SESSION_END_KEY, String(reason)); } catch (_) { /* storage gone */ }
}

export function sessionEndReason() {
  try { return localStorage.getItem(SESSION_END_KEY); } catch (_) { return null; }
}

export function clearSessionEndReason() {
  try { localStorage.removeItem(SESSION_END_KEY); } catch (_) { /* storage gone */ }
}

/**
 * Not in SESSION_KEYS, so clearing the session does not erase the explanation
 * for clearing the session.
 */
export const SESSION_END_KEY = 'session:endedBecause';

/**
 * The endings worth telling somebody about. Signing out is not among them: it
 * needs no explanation, and labelling it would put a notice on the one arrival
 * at this screen that was deliberate.
 */
export const SESSION_END_REASONS = {
  // The refresh was tried and refused — expired, revoked, or signed with a
  // secret this server no longer holds. Signing in again fixes it.
  TOKEN_REJECTED: 'token-rejected',
  // The scheduled refresh could not complete. Distinct from the above because
  // it is usually the network rather than the credential.
  REFRESH_FAILED: 'refresh-failed',
  // A deployment that has deliberately turned keepSignedIn off.
  IDLE: 'idle-timeout',
};
